import { PaymentProcessorEnum } from '@systemeio/ui'
import { MercadoPagoPaymentProcessor } from 'modules/profile/payment-gateways/integrations/mercadopago/types'

export const mercadoPagoPaymentProcessors: MercadoPagoPaymentProcessor[] = [
  PaymentProcessorEnum.MercadoPagoAR,
  PaymentProcessorEnum.MercadoPagoBR,
  PaymentProcessorEnum.MercadoPagoCL,
  PaymentProcessorEnum.MercadoPagoCO,
  PaymentProcessorEnum.MercadoPagoMX,
]
